import React from 'react';
import Item from './Item';
import {IReport} from '../../types';
import {COL_IDS} from './consts';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {getUsername} from '../../../../_shared/GWTBridge/invoke/genPage';
import texts from '../../texts';
import {getReportTypeTitle} from './utils';
import {Radio} from '../Radio/Radio';
import cx from 'classnames';
import styles from './styles.module.scss';
import {BoldItem} from './types';

export type Props = {
    report: IReport;
    searchQuery: string;
    isAnalyticsReportDialog?: boolean;
    onSelect?: (id: number) => void;
    isSelected?: boolean;
    boldItem?: BoldItem;
};

export const ReportColumns = ({
    report,
    searchQuery,
    isAnalyticsReportDialog,
    onSelect,
    isSelected,
    boldItem
}: Props) => {
    return (
        <>
            {isAnalyticsReportDialog && (
                <div className={cx(styles.tableItem)}>
                    {onSelect && (
                        <Radio
                            dataTestId={`report-list-radio-${report.title}`}
                            checked={isSelected}
                            onChange={() => onSelect(report.id as number)}
                        />
                    )}
                </div>
            )}
            <Item
                bold={boldItem === BoldItem.title}
                value={report.title}
                query={searchQuery}
                isActive={report.isActive}
                testId={`valueof-${COL_IDS.title}`}
            />
            <Item
                bold={boldItem === BoldItem.baseForm}
                value={report.baseForm}
                query={searchQuery}
                isActive={report.isActive}
                testId={`valueof-${COL_IDS.baseForm}`}
            />
            <Item
                bold={boldItem === BoldItem.reportType}
                value={getReportTypeTitle(report.reportType)}
                query={searchQuery}
                isActive={report.isActive}
                testId={`valueof-${COL_IDS.reportType}`}
            />
            {isAnalyticsReportDialog ? (
                ''
            ) : (
                <Item
                    bold={boldItem === BoldItem.createdDate}
                    isActive={report.isActive}
                    value={report.isOldReport ? '--' : report.createdDate}
                    query={searchQuery}
                    testId={`valueof-${COL_IDS.createdDate}`}
                />
            )}
            <Item
                bold={boldItem === BoldItem.userName}
                isActive={report.isActive}
                value={getUsername() === report.userName ? texts.currentUser : report.userName}
                query={searchQuery}
                testId={`valueof-${COL_IDS.userName}`}
            />
            <Item
                bold={boldItem === BoldItem.updateTime}
                isActive={report.isActive}
                isDateTime
                value={report.isOldReport ? '--' : report.updateTime}
                query={searchQuery}
                testId={`valueof-${COL_IDS.updateTime}`}
            />
            {isAnalyticsReportDialog ? (
                ''
            ) : (
                <>
                    <Item
                        isActive={report.isActive}
                        query={searchQuery}
                        testId={`valueof-${COL_IDS.isGeneral}`}
                    >
                        {report.isGeneral ? (
                            <Icon
                                icon={PriorityIcon.check}
                                iconColor={report.isActive ? 'primary-500' : 'secondary-300'}
                            />
                        ) : (
                            <Icon
                                icon={PriorityIcon.closeSmall}
                                iconColor={report.isActive ? 'primary-700' : 'secondary-300'}
                            />
                        )}
                    </Item>
                    <Item
                        isActive={report.isActive}
                        query={searchQuery}
                        testId={`valueof-${COL_IDS.isActive}`}
                    >
                        {report.isActive ? (
                            <Icon icon={PriorityIcon.check} iconColor="primary-500" />
                        ) : (
                            <Icon icon={PriorityIcon.closeSmall} iconColor="secondary-300" />
                        )}
                    </Item>
                </>
            )}
        </>
    );
};
